import styled from 'styled-components';
import {
  NeuButton,
  NeuCard,
  NeuIcon,
  NeuInput,
  NeuList,
  NeuTextarea
} from '@neutron/react';

interface ColorProps {
  color?: string;
}
interface DropdownProps {
  showPopover: boolean;
}

export const AddQuestionPartCard = styled.div`
  display: flex;
  position: fixed;
  width: 319px;
  height: 292px;
  left: calc(50% - 319px / 2);
  top: calc(50% - 292px / 2);
  background: #ffffff;
  box-shadow: 0px 2px 4px rgba(25, 25, 25, 0.2);
  border-radius: 5px;
  z-index: 10;
  padding-inline-start: 0;
`;

export const CardHeader = styled(NeuCard)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 56px;
  width: 100%;
  --background: white;
`;

export const ModalCardContent = styled(NeuCard)`
  flex: 1;
  overflow-y: scroll;
  overflow-x: hidden;
  scroll-behavior: smooth;
`;

export const RadioContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 0.9375rem;
  margin-bottom: 0.9375rem;
`;

export const RadioLabel = styled.div`
  margin-right: 30px;
  margin-left: 3px;
`;

export const ModalInput = styled(NeuInput)`
  min-height: 42px;
`;

export const DropDownSearchContainer = styled.div<DropdownProps>`
  box-shadow: 0px 2px 4px rgba(25, 25, 25, 0.2);
  border-radius: 5px;
  width: 97%;
  min-height: 27px;
  max-height: 160px;
  z-index: 10;
  position: absolute;
  top: 42px;
  background: white !important;
  opacity: 1;
  overflow-y: scroll;
  display: ${props => (props.showPopover ? 'block' : 'none')};
`;

export const DropItem = styled.p`
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 26px;
  padding: 1px;
  opacity: 1;
`;

export const ModalFooter = styled(NeuCard)`
  background: white !important;
  bottom: 0;
  height: 69px !important;
`;

export const TitleSpan = styled.span`
  display: flex;
  font-size: 16px;
  line-height: 26px;
  color: #06173d;
  width: 280px;
`;
export const TitleSpanView = styled.span`
  display: flex;
  font-size: 16px;
  line-height: 26px;
  color: #06173d;
  width: 280px;
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
export const TitleIcon = styled(NeuIcon)`
  margin-right: 8px;
  color: #5d99c8;
`;
export const FeedbackViewDiv = styled.div`
  margin-top: 15px;
`;
export const CompletedTextDiv = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 26px;
  color: #000000;
`;
export const FeedbackViewDiv2Column = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 15px;
`;
export const LabelHeading = styled.div`
  width: 100%;
  margin-top: 15px;
  font-size: 14px;
  line-height: 22px;
`;
export const LabelContent = styled.div`
  width: 100%;
  margin-top: 5px;
  font-size: 16px;
  line-height: 26px;
  color: #191919;
`;
export const LabelContentPatient = styled.div<ColorProps>`
  width: 100%;
  margin-top: 5px;
  font-weight: 700;
  font-size: 16px;
  line-height: 26px;
  color: ${props => props.color};
`;
export const LabelContentBold = styled.div`
  width: 100%;
  margin-top: 5px;
  font-weight: 700;
  font-size: 16px;
  line-height: 26px;
  color: #191919;
`;
export const FeedbackViewSubDiv = styled.div`
  width: 50%;
`;

export const FooterDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
export const DateDiv = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
`;
export const ChipWrapper = styled.span``;

export const QuestionPartTypeListItem = styled(NeuList)`
  div.neu-list--wrapper {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  div.neu-list--content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`;

export const UpdatesWrapper = styled.div`
  margin-top: 23px;
`;
export const UpdatesItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding: 5px;
`;
export const UpdatesIconContainer = styled.div`
  display: flex;
  align-items: flex-start;
`;
export const UpdatesInfoContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0px 10px;
  border-bottom: 1px solid #b0b0b0;
  padding-bottom: 5px;
`;
export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`;
export const UpdateTitle = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 26px;
  color: #124e7f;
`;
export const UpdateDate = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 22px;
  color: #686868;
  margin-left: 10px;
`;
export const DetailsContainer = styled.div`
  font-size: 16px;
  line-height: 26px;
  color: #373737;
`;
export const InputContainer = styled.div`
  margin-bottom: 36px;
`;
export const UpdatesTextArea = styled(NeuTextarea)`
  width: 100%;
`;
